module.exports = __webpack_public_path__ + "static/toolbelt-c420f4005cf3091b1c55cd0d85fc183d.jpg";